import { Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Formulário de cadastro da loja como emitente na Spedy (passo 1 da
 * configuração fiscal). Os dados vão para o cabeçalho de toda nota emitida,
 * então precisam bater com o cartão CNPJ — não é o nome comercial do dia a dia.
 */

function Campo({ label, children, className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Label className="text-[11px] font-medium">{label}</Label>
      {children}
    </div>
  );
}

export default function FormEmpresaFiscal({ form, setForm, onSubmit, salvando }) {
  return (
          <div className="space-y-3">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <Campo label="CNPJ *">
                <Input autoComplete="off" value={form.cnpj} onChange={(e) => setForm({ ...form, cnpj: e.target.value })} placeholder="00.000.000/0000-00" className="h-9 text-sm font-mono" />
              </Campo>
              <Campo label="Inscrição Estadual">
                <Input autoComplete="off" inputMode="numeric" value={form.inscricao_estadual} onChange={(e) => setForm({ ...form, inscricao_estadual: e.target.value.replace(/\D/g, "").slice(0, 14) })} placeholder="Só números, sem ponto nem hífen" className="h-9 text-sm font-mono" />
              </Campo>
              <Campo label="E-mail">
                <Input autoComplete="off" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="Razão social *" className="sm:col-span-2">
                <Input autoComplete="off" value={form.razao_social} onChange={(e) => setForm({ ...form, razao_social: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="Nome fantasia *">
                <Input autoComplete="off" value={form.nome_fantasia} onChange={(e) => setForm({ ...form, nome_fantasia: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="Logradouro *" className="sm:col-span-2">
                <Input autoComplete="off" value={form.logradouro} onChange={(e) => setForm({ ...form, logradouro: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="Número *">
                <Input autoComplete="off" value={form.numero} onChange={(e) => setForm({ ...form, numero: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="Complemento">
                <Input autoComplete="off" value={form.complemento} onChange={(e) => setForm({ ...form, complemento: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="Bairro *">
                <Input autoComplete="off" value={form.bairro} onChange={(e) => setForm({ ...form, bairro: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="CEP *">
                <Input autoComplete="off" value={form.cep} onChange={(e) => setForm({ ...form, cep: e.target.value })} placeholder="00000-000" className="h-9 text-sm font-mono" />
              </Campo>
              <Campo label="Município *" className="sm:col-span-2">
                <Input autoComplete="off" value={form.municipio} onChange={(e) => setForm({ ...form, municipio: e.target.value })} className="h-9 text-sm" />
              </Campo>
              <Campo label="UF *">
                <Input autoComplete="off" value={form.uf} onChange={(e) => setForm({ ...form, uf: e.target.value.toUpperCase().slice(0, 2) })} placeholder="SP" className="h-9 text-sm font-mono" />
              </Campo>
            </div>
            <Button onClick={onSubmit} disabled={salvando} className="h-9">
              {salvando ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Cadastrando...</> : "Conectar NFe Fácil"}
            </Button>
          </div>
  );
}
